import { apiClient } from './axios';
import type { PaginationData } from '../models/paginationData';
import type { PageRequest } from '../models/pageRequest';
import type {
    AdminAiLogResolution,
    AdminAiRequestLog,
    AdminAiRequestLogDetail,
} from '../types/aiLog';

export interface AiLogFilterParams extends PageRequest {
    provider?: string;
    requestType?: string;
    externalBatchId?: string;
    workflowOnly?: boolean;
    isSuccess?: boolean;
    resolutionStatus?: 'OPEN' | 'RESOLVED';
    userId?: number;
    fromDate?: string;
    toDate?: string;
}

export interface UpdateAiLogResolutionReq {
    resolved: boolean;
    resolutionNote?: string;
}

export const aiLogApi = {
    getRequestLogs: (params: AiLogFilterParams) => {
        const {
            page,
            size,
            provider,
            requestType,
            externalBatchId,
            workflowOnly,
            isSuccess,
            resolutionStatus,
            userId,
            fromDate,
            toDate,
        } = params;
        return apiClient.get<PaginationData<AdminAiRequestLog>>('/admin/ai/request-logs', {
            page: page - 1,
            size,
            ...(provider ? { provider } : {}),
            ...(requestType ? { requestType } : {}),
            ...(externalBatchId ? { externalBatchId } : {}),
            ...(workflowOnly !== undefined ? { workflowOnly } : {}),
            ...(isSuccess !== undefined ? { isSuccess } : {}),
            ...(resolutionStatus ? { resolutionStatus } : {}),
            ...(userId ? { userId } : {}),
            ...(fromDate ? { fromDate } : {}),
            ...(toDate ? { toDate } : {}),
        });
    },

    getRequestLogDetail: (logId: number) =>
        apiClient.get<AdminAiRequestLogDetail>(`/admin/ai/request-logs/${logId}`),

    updateRequestLogResolution: (logId: number, data: UpdateAiLogResolutionReq) =>
        apiClient.patch<AdminAiLogResolution>(`/admin/ai/request-logs/${logId}/resolution`, data),
};
